import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth25: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M32.5,148.5l-11.1-38.8-6-32.5-.2-15.1,5.1-10.6,7.9-8.4,15.6-11,16.2-7.3,4.5-1.5h13.6l9.4,3.4,12.6,5.8,11.3,9.4,10.6,11,4.7,6.2,3.8,9.8,1.8,6.2.2,16.6-1.5,11.8-4.7,18.9-3.6,9-5.8,12.6c-39.3,25.9-84.4,4.5-84.4,4.5Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M116.9,144l5.8-12.6,3.6-9,3-9.4h-23.3s-11.3.9-11.3-8.4l.2-41.2-41.9-.2.2,41.9s.2,9.1-10.6,9.1l-20-.2,9.8,34.5s43.3,22.1,84.4-4.5Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M53.3,105.1l-.2-41.9V26.4l-14.6,8.1-12.7,10-7.7,8.6-3.8,8.8-.5,12.9,9,39.2,20,.2s10.8,1,10.6-9.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M94.7,104.6V28.4l12,8.4,10,9.5,8.1,9,5.2,9.5,2.5,10.9v18.3l-.7,7.9-2.5,11.1h-23.3s-11.3.8-11.3-8.4Z',
			},
			[ToothSurface.PalatalCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '53 63.2 94.9 63.2 130 63.2 124.9 55.5 118.8 47.7 112 41.2 103 33.2 97.9 29.9 91.1 26.4 81.3 23.6 75 22.1 68.2 22.3 64.5 22.3 57.6 24.6 51.2 26.6 43.2 30.9 37.5 35.4 33.4 37.9 27.9 42.4 23.2 46.3 17.6 53 15.2 59.4 14.8 62.9 53 63.2',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M32.5,148.5s43.1,21.1,84.4-4.5l-2.6,9.2s-34.8,28.3-80.1,3.7l-1.7-8.4Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M32.5,148.5l-11.1-38.8-6-32.5-.2-15.1,5.1-10.6,7.9-8.4,15.6-11,16.2-7.3,4.5-1.5h13.6l9.4,3.4,12.6,5.8,11.3,9.4,10.6,11,4.7,6.2,3.8,9.8,1.8,6.2.2,16.6-1.5,11.8-4.7,18.9-3.6,9-5.8,12.6c-39.3,25.9-84.4,4.5-84.4,4.5Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'17.5 83.8 29.6 102.1 35.6 76.5 43.7 107.6 54.1 75.7 63.7 107.6 74.5 76 84.4 107.6 95.2 73.9 103.9 105.9 115.6 73.9 119.1 100.8 132 81.6',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'75.3 156 63.7 164 76.9 173.7 65 182.1 77.4 190.9 66.1 198.7 77.2 206.7 66.1 214.3 78.9 223.4 68.2 230.8 78.4 238 67.7 245.4 80.1 249.3 68.7 258.5 82 265.5 69.5 274.2 83.5 280.1 72.4 291.1 87 297.8 73.7 306.7 88.8 313.3 75 323.5 88.5 330.2 77.4 338.6 90.2 346.8 79.1 357.6 92.2 364.6 81.2 374.5 87.9 393.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'47.5 258.2 51.1 269.7 55.3 257.6 59.8 268.6 65.1 258.5 71.4 270.4 77.2 256.1 84.1 269.7 90.9 256.1 96.7 268.6 102.4 256.4',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '15.9 92.3 15.7 79.7 20 70.7 26.9 61.8 34.9 54.1 43.9 48.7 53.9 44.6 64.2 42.6 81.3 42.2 92.7 45 102 48.3 111 53.9 117.9 61.2 122 67.2 125.7 73.7 128.5 80 129.8 85.8 130.4 89.7 130.2 103.5 129.1 112.8 126.8 123.1 122.2 135.6 115.1 148.6 108.2 158.1 99.4 164.3 88.8 168.2 74.6 168.4 65.3 165.2 56.7 160 50.4 154.4 41.1 141.7 27.5 122.2 20.6 107.1 15.9 92.3',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M18.1,75.4s14.5,14.7,27.4,18.4,18.7-6.9,28.5-6.9,13.5,13.1,30.6,6.2,22.3-17.1,22.3-17.1l-3.9-9-6.2-8.1-5.7-5.6-7.6-5.1-11.3-4.4-9.3-2.4h-13l-9.5.7-11.3,3.5-10.5,4.7-8.4,6.8-7.3,7.6-4.7,10.5Z',
			},
			[ToothSurface.PalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M124.1,133s-11.5-8.6-23.6-11.5-14.5,6.2-23.6,6.2-8.9-10.2-23-6.8-19.1,12.8-19.1,12.8l10.1,15.2,7.9,8.3,9.3,7.3,11.7,3.7,15.7-.2,9.8-3.2,11.1-8.4,8.6-13.7,5.1-9.8Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M18.1,75.4l-2,5.4v12.3l2.9,10,7.3,15.7,8.6,15,6.9-6.6s17.9-18.2-3.5-36.6l-20.1-15.2Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M126.8,76.1l2.5,5.6,1.5,8.6.2,14-1.4,11.3-5.6,17.4-10.5-6.1s-29.6-16-.8-38.2l14-12.7Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M38.2,90.6l7.3,3.2c16,2.1,17.6-6.2,28.5-6.9s11.5,13.1,30.6,6.2l6.9-3.2s-26.6,18.8,2.2,36.9c0,0-3.9-2.9-13.2-5.4s-15.4,6.2-23.6,6.2-12.9-9.6-23-6.8-10.9,4.9-10.9,4.9c0,0,4.3-12.3,4.3-19.9s-9.1-15.3-9.1-15.3Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M18.1,75.4l4.7-10.5,7.3-7.6,8.4-6.8,10.5-4.7,11.3-3.5,9.5-.7h13l9.3,2.4,11.3,4.4,7.6,5.1,5.7,5.6,6.2,8.1,3.9,9s-26.6-28-108.8-.7Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M34.8,133.8l10.1,15.2,7.9,8.3,9.3,7.3,13,4.5h14.1c0-.1,10-4.2,10-4.2l11.1-8.4,8.6-13.7,5.1-9.8s-40.7,36.3-89.3.8Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'18.9 96.9 33 110.4 36.5 88.3 47.4 114.8 55.9 88.3 66.2 116 75.8 89.9 85.9 116 95.3 89.6 105.2 116 112.9 90.2 118.6 111.3 130.1 96.2',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.3,370.9l-6.5,28.2-2.8,21.3-3,27.5,1.8,11.5,9.1,11.9,17.9,11.5,22.7,7.6,14.4.4,24.5-11.2,14.8-12.6,10.6-17,4.3-10.3-.2-20.2-7.3-21.3-7-20.5s-40.7-46-93.2-6.9Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.3,370.9s45.8-39.8,93.2,6.9l9.9,28.4h-15.6s-20.6-.5-20.6,13.9v34.3h-39.4v-34.1s-1.4-13.5-16.2-13.5h-19.5l8.2-35.9Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.1,406.8l-3.9,44.6,2.3,8.9,6.6,9.4,10.7,7.5,20.2,10.3-.2-33v-34.1s-.5-13.5-16.2-13.5h-19.5Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M130.5,406.2l2.7,12.6,1.2,9.4-.4,12.3-5,12.4-15.8,19.4-18.3,13.1-.7-31.1v-34.3s-2.1-13.9,20.6-13.9h15.6Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '94.3 454.4 54.8 454.4 15.9 454.4 19 462.9 28.9 473.4 41.7 481.2 58.7 488.3 67.8 490.4 80.2 490.2 93.2 486.3 107.8 476.9 119.7 465 128.1 454.7 94.3 454.4',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.3,370.9l-6.5,28.2-2.8,21.3-3,27.5,1.8,11.5,9.1,11.9,17.9,11.5,22.7,7.6,14.4.4,24.5-11.2,14.8-12.6,10.6-17,4.3-10.3-.2-20.2-7.3-21.3-7-20.5s-40.7-46-93.2-6.9Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.3,370.9s44.8-38.3,93.2,6.9l-4.9-11.2s-37-46.8-86.3-4.7l-2,8.9Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'133 435.3 117 413.6 111.3 438.6 103.5 408.1 93.4 439.5 84 408.1 73.5 439.1 63.9 408.1 53.4 441.1 44.8 409.8 33.5 441.1 30.1 414.8 17.9 431.8',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'67.9 376.5 84.9 362.7 68.1 351.6 83.2 341.9 67.6 331.7 81.8 322.9 67.8 313.6 81.8 304.9 65.5 294.5 79.2 285.9 66.3 277.7 79.8 269.1 65.9 259.9 80.1 250.9 66.8 242.2 81.2 233.4 68.9 225.3 83 216.4 68.1 206.6 84.5 196.3 70 186.8 86.1 176.6 71.5 167 87.3 157 72.5 149.3 85.7 138.8 74.9 129.3 87.7 120.2 84 102.9',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'102.9 254.8 99.4 239 91.5 255 85.7 239.5 80.1 255.1 72.2 238.7 64.2 255.6 57.6 238.7 51.8 256.1 44.8 240.3 39.8 256.3',
			],
		},
	},
};
